const data = [
  {
    id: "1",
    titleItem: "Elecciones del 01 de junio de 2025 – Elección Judicial ",
    description: "Consejero Presidente Emmanuel Ávila González",
    facebookUrl: "https://www.facebook.com/watch/?v=1827089174758517"
  },
  {
    id: "2",
    titleItem: "proceso de contratación de SEL y CAEL para la elección del poder judicial 2025",
    description: "Consejero Electoral Edgar Alfonso Aldave",
    facebookUrl: "https://www.facebook.com/watch/?v=919037563635869"
  },
  {
    id: "3",
    titleItem: "la Red de Mujeres Juzgadoras Candidatas y Electas ",
    description: "Consejera Electoral Janet Cervantes",
    facebookUrl: "https://www.facebook.com/watch/?v=1843692823097652"
  },
  {
    id: "4",
    titleItem: "Documentación electoral para el Proceso Electoral Judicial 2025",
    description: "Consejera Electoral Erika Periañez Rodríguez",
    facebookUrl: "https://www.facebook.com/watch/?v=679614837822726"
  },
  {
    id: "5",
    titleItem: "Listas de candidaturas para el Proceso Electoral Judicial 2025 ",
    description: "Consejera Electoral Anakaren Montserrat Rojas Cuautle",
    facebookUrl: "https://www.facebook.com/watch/?v=1003315381222273"
  },
  {
    id: "6",
    titleItem: "Observadoras y Observadores Electorales ",
    description: "Titular del Área Técnica de Consulta Ciudadana del ITE, Ana Lilia Arévalo,",
    facebookUrl: "https://www.facebook.com/watch/?v=1397259821295969"
  },
  {
    id: "7",
    titleItem: "Topes de gastos personales de campaña para la Elección Judicial Local 2025",
    description: "Consejera Electoral Yedith Martínez Pinillo ",
    facebookUrl: "https://www.facebook.com/watch/?v=9641580825879998"
  },
  {
    id: "8",
    titleItem: "Medidas de seguridad que se emplearán en las boletas electorales del Proceso Electoral Local Extraordinario 2025. ",
    description: "Consejera Electoral Erika Periañez Rodríguez, ",
    facebookUrl: "https://www.facebook.com/watch/?v=664192972999442"
  },
  {
    id: "9",
    titleItem: "foros de debate para el Proceso Electoral Local Extraordinario 2025.",
    description: "Consejero Electoral Edgar Alfonso Aldave Aguilar",
    facebookUrl: "https://www.facebook.com/watch/?v=659838563569623"
  },
  {
    id: "10",
    titleItem: "Consejos distritales y su importancia para el Proceso Electoral Local Extraordinario 2025",
    description: "Consejera Electoral Anakaren Monserrat Rojas",
    facebookUrl: "https://www.facebook.com/watch/?v=1778791369645286"
  },
  {
    id: "11",
    titleItem: "Sistema Candidatas y Candidatos Conóceles",
    description: "Consejero Electoral Hermenegildo Neria Carreño",
    facebookUrl: "https://www.facebook.com/watch/?v=942003187880914"
  },
  {
    id: "12",
    titleItem: "Foros de Debate del Proceso Electoral Local Extraordinario 2025",
    description: "Consejero Electoral Edgar Alfonso Aldave Aguilar",
    facebookUrl: "http://facebook.com/watch/?v=690773446773482"
  },
  {
    id: "13",
    titleItem: "Importancia de la Participación Ciudadana en el Proceso Electoral Local Extraordinario 2025 ",
    description: "Yedith Martínez Pinillo ",
    facebookUrl: "https://www.facebook.com/watch/?v=719904494049077"
  },
  {
    id: "14",
    titleItem: "como votar en esta Elección Judicial Local 2025",
    description: "Consejera Electoral Anakaren Rojas Cuautle ",
    facebookUrl: "https://www.facebook.com/watch/?v=1943706939787986"
  },
  {
    id: "15",
    titleItem: "Jornada Electoral de este 01 de junio ",
    description: "Consejero Electoral Edgar Alfonso Aldave",
    facebookUrl: "https://www.facebook.com/watch/?v=1682433845967294"
  },
  {
    id: "16",
    titleItem: "Cómputos de la Elección Judicial Local 2025 ",
    description: "Consejera Electoral Anakaren Rojas Cuautle",
    facebookUrl: "https://www.facebook.com/watch/?v=688707017308812"
  },
  {
    id: "17",
    titleItem: "Requisitos de Elegibilidad de la Elección Judicial Local 2025",
    description: "Consejera Electoral Janet Cervantes",
    facebookUrl: "https://www.facebook.com/watch/?v=1881850845999519",
  },
  {
    id: "18",
    titleItem: "La participación política de la comunidad LGBTTIQ+",
    description: "Heizel Sánchez Nava, Integrante del Comité de la Diversidad en Tlaxcala",
    facebookUrl: "https://www.facebook.com/watch/?v=3932969903699883",
  },
  {
    id: "19",
    titleItem: "Violencia Política contra las Mujeres en razón de Género",
    description: "Regidora del Ayuntamiento de Cuapiaxtla María Isabel Bautista",
    facebookUrl: "https://www.facebook.com/watch/?v=750049791292956",
  },
  {
    id: "20",
    titleItem: "70 aniversario del Sufragio Femenino en México.",
    description: "Consejera Electoral Erika Periañez",
    facebookUrl: "https://www.facebook.com/watch/?v=30801039016176692",
    nuevo: "1" 
  },
];

// Ordenar de mayor a menor por id (conversión a número para evitar errores)
export const EnCorto = data.sort((a, b) => Number(b.id) - Number(a.id));
